import React from 'react';

const About = () => {
  const steps = [
    {
      title: 'Level 1',
      text: 'Du startest ohne Vorkenntnisse und lernst die arabischen Buchstaben sicher zu lesen, zu schreiben und richtig auszusprechen.',
    },
    {
      title: 'Level 2',
      text: 'Mit Madina Buch 1 und Arabya Bayna Yadayk 1 lernst du die ersten Wörter, einfache Sätze und grundlegende Grammatik.',
    },
    {
      title: 'Level 3',
      text: 'Mit Madina Buch 2 und Arabya Bayna Yadayk 2 baust du dein Verständnis aus und lernst längere zusammenhängende Texte zu verstehen.',
    },
    {
      title: 'Level 4',
      text: 'Mit Madina Buch 3 und Arabya Bayna Yadayk 3 vertiefst du Grammatik, Wortschatz und Ausdruck.',
    },
    {
      title: 'Level 5',
      text: 'Mit Al-Ajrumiyyah und Arabya Bayna Yadayk 4 arbeitest du intensiver an Grammatik und einem tieferen Verständnis.',
    },
  ];

  return (
    <section id="about" className="relative bg-white py-16 md:py-24">
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="max-w-2xl mb-10 md:mb-14">
          <p className="text-xs font-semibold tracking-[0.12em] uppercase text-[#970000] mb-3">
            Unsere Vision
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-[-0.04em] leading-[1.1] text-gray-900">
            Arabisch lernen —{' '}
            <span className="oblique font-extrabold text-[#970000]">und endlich verstehen</span>
          </h2>
          <p className="mt-4 text-[15px] md:text-[17px] leading-relaxed text-gray-500">
            Ein klarer Lernweg — vom ersten Buchstaben bis zum echten Verständnis der Sprache.
          </p>
        </div>

        {/* Content grid */}
        <div className="grid lg:grid-cols-2 gap-6 md:gap-8 items-start">

          {/* Left — text */}
          <div>
            <p className="text-xs font-semibold tracking-[0.12em] uppercase text-[#970000] mb-4">
              Warum Arabicroots
            </p>
            <h3 className="text-2xl md:text-3xl font-bold tracking-[-0.03em] leading-[1.25] text-gray-900 mb-5">
              Ein Lernsystem, das dich nicht überfordert, sondern Schritt für Schritt voranbringt.
            </h3>
            <div className="space-y-4 text-[15px] leading-[1.8] text-gray-500">
              <p>
                Wir wissen aus eigener Erfahrung, wie schwer es sein kann, Arabisch zu lernen — besonders wenn Alltag, Arbeit, Studium oder Familie da sind und die Zeit fehlt.
              </p>
              <p>
                Viele beginnen motiviert, verlieren aber die Struktur oder wissen nicht mehr, wie sie weitermachen sollen. Es fehlt ein klarer Weg.
              </p>
              <p>
                Genau deshalb wurde Arabicroots gegründet:{' '}
                <span className="font-semibold text-gray-700">
                  Arabisch verständlich, strukturiert und auf Deutsch zu vermitteln
                </span>{' '}
                — ohne Chaos, ohne Überforderung.
              </p>
            </div>
          </div>

          {/* Right — red panel with steps */}
          <div className="relative overflow-hidden rounded-2xl bg-[#b30000] p-5 md:p-8 text-white">
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/15 via-transparent to-black/15" />

            <div className="relative">
              <p className="text-xs font-semibold tracking-[0.12em] uppercase text-white/60 mb-3">
                Dein Weg mit Arabicroots
              </p>
              <h3 className="text-xl md:text-2xl font-bold tracking-[-0.03em] leading-[1.25] text-white mb-8">
                So lernst du Arabisch Schritt für Schritt
              </h3>

              <div className="space-y-0">
                {steps.map((step, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="flex flex-col items-center pt-1 shrink-0">
                      <div className="h-2.5 w-2.5 rounded-full bg-white" />
                      {index !== steps.length - 1 && (
                        <div className="mt-1 mb-1 h-12 w-px bg-white/25" />
                      )}
                    </div>
                    <div className={`pb-1 ${index !== steps.length - 1 ? 'mb-1' : ''}`}>
                      <h4 className="text-[14px] font-semibold text-white mb-1">
                        {step.title}
                      </h4>
                      <p className="text-[13px] text-white/70 leading-relaxed">
                        {step.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
